import React from "react";
import { useTranslation } from "react-i18next";

const GameResult = ({game}) => {
    const {t} = useTranslation("General");


return (
    <React.Fragment>
       
            <div className="w-50 text-end pe-2 d-flex justify-content-end align-items-center text-truncate">
                <div className="w-100 text-end text-truncate">
                    <strong className="pe-2">{t(`${game.homeTeam.teamName}`)}</strong>
                </div>
                <img
                    width={"24px"}
                    src={
                        process.env.PUBLIC_URL +
                        "/assets/images/teams/" + game?.leagueRef + "/" +
                        game.homeTeam.teamImageURL
                    }
                    alt=""
                />
            </div>
            <div className="d-flex justify-content-center align-items-center border border-1 px-2 py-1 rounded">
                <div className="text-center h4 fw-normal m-0 mx-1 rounded-3">
                    {game.homeTeamGoals}
                </div>
                <b className="px-2 fw-bold text-center">:</b>
                <div className="text-center h4 fw-normal m-0 mx-1 rounded-3">
                    {game.awayTeamGoals}
                </div>
            </div>
            <div className="w-50 text-end ps-2 d-flex justify-content-end align-items-center text-truncate">
                <img
                    width={"24px"}
                    src={
                        process.env.PUBLIC_URL +
                        "/assets/images/teams/" + game?.leagueRef + "/" +
                        game.awayTeam.teamImageURL
                    }
                    alt=""
                />
                <div className="w-100 text-start text-truncate">
                    {" "}
                    <strong className="ps-2">{t(`${game.awayTeam.teamName}`)}</strong>
                </div>
            </div>
    </React.Fragment>
)
}
export default GameResult;